<template>
  <v-container fluid full-height grid-list-md>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6 v-if="user.roleName != 'ADMIN' && user.roleName != 'BRANCH_ADMIN'">
        <div class="text-xs-right">
          <v-btn color="primary" @click="onRegister">
            New Whole Sale
            <v-icon right>add_circle</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3 v-if="user.role.roleName != 'SALE'">
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3 v-if="user.role.roleName != 'SALE'">
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3 v-if="user.role.roleName == 'ADMIN' || user.role.roleName == 'BRANCH_ADMIN'">
              <v-select
                :items="shopList"
                label="Choose Shop..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                v-model="queryParams.shopId"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="customerName"
                label="Customer Name"
                type="text"
                v-model="queryParams.customerName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="customerCode"
                label="Customer Code"
                type="text"
                v-model="queryParams.customerCode"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
                <v-autocomplete
                  v-model="queryParams.currencyId"
                  :items="currencyList"
                  color="blue-grey lighten-2"
                  label="Choose Currency..."
                  item-text="code"
                  menu-props="auto"
                  item-value="id"
                ></v-autocomplete>
              </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-card-title class="blue darken-3">
                  <span class="headline white--text">Summary</span>
                </v-card-title>
                <v-card-text class="font-weight-bold">
                  <div>
                    <span>Total Net Amount :</span>
                    <v-chip>
                      <span>{{ totalNetAmount | decFormat}}</span>
                    </v-chip>
                    <v-btn
                      color="primary"
                      :loading="buttonLoading"
                      @click="reprintAllWholeSale('printAllWholeSale')"
                    >PRINT ALL</v-btn>
                    <v-btn
                      :loading="buttonLoading"
                      color="success"
                      @click="exportAllWholeSale()"
                    >EXPORT ALL</v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 class="mt-1">
              <v-card>
                <v-data-table
                  :headers="headers"
                  :items="wholeSaleList"
                  class="elevation-1"
                  :loading="showListLoading"
                  :total-items="totalRows"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  :must-sort="true"
                  expand
                >
                  <template slot="items" slot-scope="props">
                    <tr @click="props.expanded = !props.expanded">
                      <td>{{ props.item.issueDateInMilliSeconds | format-ms-date }}</td>
                      <td>{{ props.item.issueNo }}</td>
                      <td>{{ props.item.customer.code }}</td>
                      <td>{{ props.item.customerName }}</td>
                      <td>{{ props.item.shopName }}</td>
                      <td>{{ props.item.status }}</td>
                      <td>{{ props.item.description }}</td>
                      <td>{{ props.item.netAmount  | decFormat }}</td>
                      <td>{{ props.item.currencyCode }}</td>
                      <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
                      <td>{{ props.item.updatedBy }}</td>
                      <td>
                        <v-btn flat icon color="blue lighten-2" @click.stop="onEdit(props.item)">
                          <v-icon>edit</v-icon>
                        </v-btn>
                        <v-btn flat icon color="blue lighten-2" @click.stop="print(props.item.id)">
                          <v-icon>print</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                  <template slot="expand" slot-scope="props">
                    <v-card class="elevation-1">
                      <v-card-text>
                        <v-data-table
                          :headers="subHeaders"
                          :items="props.item.wholeSaleDetails"
                          item-key="props.item.id"
                          hide-actions
                          class="elevation-10"
                        >
                          <template slot="items" slot-scope="subprops">
                            <td class="text-xs">{{ subprops.item.product.name }}</td>
                            <td class="text-xs">{{ subprops.item.product.color }}</td>
                            <td class="text-xs">
                              <v-icon
                                center
                                color="success"
                                v-if="subprops.item.isFOC == true"
                              >check_circle</v-icon>
                            </td>
                            <td class="text-xs">
                              <v-icon
                                center
                                color="success"
                                v-if="subprops.item.isReturn == true"
                              >check_circle</v-icon>
                            </td>
                            <td
                              class="text-xs"
                            >{{ subprops.item.productUnit.factor+"/"+subprops.item.productUnit.unitName}}</td>
                            <td class="text-xs">{{ subprops.item.unitPrice | decFormat }}</td>
                            <td class="text-xs">{{ subprops.item.qty }}</td>
                            <td
                              class="text-xs"
                            >{{ subprops.item.unitPrice * subprops.item.qty | decFormat }}</td>
                            <td class="text-xs">{{ subprops.item.returnQty }}</td>
                            <td
                              class="text-xs"
                            >{{ subprops.item.unitPrice * subprops.item.returnQty | decFormat }}</td>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- <summary report> -->
    <div id="printAllWholeSale" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center">
        <p style="font-size:18px;margin:1px">Sale Summary</p>
      </div>
      <div style="text-align:center">
        <p
          style="font-size:15px;margin:1px"
        >From: [{{queryParams.fromDate}}] To: [{{queryParams.toDate}}]</p>
      </div>
      <div style="text-align:left">
        <p style="font-size:15px;margin:0px">Total Amount: {{totalNetAmount | decFormat}}</p>
      </div>
      <br />
      <div style="padding-left:5px;padding-right:5px">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;border-top:1px solid black"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr>
              <th style="text-align:left">Issue Date</th>
              <th style="text-align:left">Issue No</th>
              <th style="text-align:left">Customer Code</th>
              <th style="text-align:left">Customer Name</th>
              <th style="text-align:left">Shop</th>
              <th style="text-align:left">Status</th>
              <th style="text-align:left">Description</th>
              <th style="text-align:left">Net Amount</th>
              <th style="text-align:left">Currency</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allWholeSaleList" :key="index">
              <td style="text-align:left">{{item.issueDateInMilliSeconds | format-ms-date}}</td>
              <td style="text-align:left">{{item.issueNo}}</td>
              <td style="text-align:left">{{item.customer.code}}</td>
              <td style="text-align:left">{{item.customer.name}}</td>
              <td style="text-align:left">{{item.shopName}}</td>
              <td style="text-align:left">{{item.status}}</td>
              <td style="text-align:left">{{item.description}}</td>
              <td style="text-align:left">{{item.netAmount | decFormat}}</td>
              <td style="text-align:left">{{item.currencyCode}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>
<script>
import { wholeSaleService } from "../../services/whole-sale-service";
import { shopService } from "../../services/shop-service";
import { commonService } from "../../services/common-service";
import { currencyService } from "../../services/currency-service";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "WholeSaleList",
  components: { Loading },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    breadcrumbs: [
      {
        text: "General",
        disabled: true
      },
      {
        text: "Whole Sale",
        disabled: true
      }
    ],
    headers: [
      { text: "IssueDate", align: "left", value: "issueDate" },
      { text: "Issue No.", value: "issueNo" },
      { text: "Customer Code", value: "customer.code" },
      { text: "Customer Name", value: "customer.name" },
      { text: "Shop", value: "shop.name" },
      { text: "Status", value: "status", sortable: false },
      { text: "Description", value: "description" },
      { text: "Net Amount", value: "netAmount" },
      { text: "Currency", value: "currency" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
      { text: "Action", value: "name", sortable: false }
    ],
    subHeaders: [
      { text: "Product Name", sortable: false },
      { text: "Product Color", sortable: false },
      { text: "FOC", sortable: false },
      { text: "Return", sortable: false },
      { text: "Factor/Unit", sortable: false },
      { text: "Unit Price", sortable: false },
      { text: "Qty", sortable: false },
      { text: "Total Amount", sortable: false },
      { text: "Return Qty", sortable: false },
      { text: "Total Return Amount", sortable: false }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0
    },
    wholeSaleList: [],
    allWholeSaleList: [],
    totalRows: 0,
    statusList: [
      { label: "All", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "QUOTATION", value: "QUOTATION" },
      { label: "FINISHED", value: "FINISHED" },
      { label: "CANCEL", value: "CANCEL" }
    ],
    clonequeryParams: new Object(),
    currencyList: [],
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      status: "",
      customerName: "",
      customerCode: "",
      shopId: "",
      currencyId: ""
    },
    totalNetAmount: 0,
    isLoading: false,
    buttonLoading: false,
    fullPage: true,
    shopList: []
  }),
  watch: {
    pagination: {
      handler() {
        this.getWholeSaleList();
      },
      deep: true
    }
  },

  created() {
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }

    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }

    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.shopId) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }

    if (this.$route.query.customerName) {
      this.queryParams.status = this.$route.query.status;
    }

    if (this.$route.query.customerCode) {
      this.queryParams.status = this.$route.query.status;
    }

    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    let user = JSON.parse(localStorage.getItem("user"));
    if (user.role.roleName == "ADMIN" || user.role.roleName == "BRANCH_ADMIN") {
      this.getAllShop();
    }
    this.getActiveCurrency()
    .finally(() => {
        this.onSearch();
    });
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "whole-sales", query: this.queryParams });
      this.getWholeSaleList();
      this.clonequeryParams = Object.assign({}, this.queryParams);
    },
    exportAllWholeSale() {
      this.buttonLoading = true;
      wholeSaleService
        .exportWholeSaleExcel(this.clonequeryParams)
        .then(res => {
          commonService.downloadE(res);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
    reprintAllWholeSale(divName) {
      this.buttonLoading = true;
      wholeSaleService
        .getAllWholeSaleList(this.clonequeryParams)
        .then(res => {
          if (res.data) {
            this.totalNetAmount = 0.0;
            this.allWholeSaleList = res.data.wholeSaleHeaderList;
            for (let temp of this.allWholeSaleList) {
              this.totalNetAmount += temp.netAmount;
            }
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.buttonLoading = false;
        });
    },

    getAllShop() {
      shopService
        .getAllShop()
        .then(res => {
          this.shopList = res.data;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.shopList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },

    getWholeSaleList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      wholeSaleService
        .getWholeSaleList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.totalNetAmount = 0.0;
            this.wholeSaleList = res.data.wholeSaleHeaderList;
            this.totalRows = res.data.totalElements;
             for (let temp of this.wholeSaleList) {
              this.totalNetAmount += temp.netAmount;
            }
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    onRegister() {
      this.$router.push("/whole-sale/new");
    },

    onEdit(wholeSale) {
      // go to details page
      this.$router.push("/whole-sale/" + wholeSale.id);
    },

    getActiveCurrency(){
    return currencyService.getCurrencyByStatus('ACTIVE')
    .then(res => {
      if(res.data){
        this.currencyList = res.data;
        let c = commonService.search("defaultCurrency",true,this.currencyList);
        if(c){
          this.queryParams.currencyId = c.id;
        }
      }
    })
    .catch((err) => {
          if (err.response.data) {
            this.responseError = err.responseError.data.message;
          }
        });
    },

    print(id) {
      this.isLoading = true;
      wholeSaleService
        .printInvoiceById(id)
        .then(res => {
          var blob = res;
          wholeSaleService.showWindowDialog(blob, "WholeSaleInvoice-" + id);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
